import { render, staticRenderFns } from "./PrizeOrder.vue?vue&type=template&id=eefa3322&scoped=true"
import script from "./PrizeOrder.vue?vue&type=script&lang=js"
export * from "./PrizeOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefa3322",
  null
  
)

export default component.exports